import React from 'react';
import NoticeStoreList from '../NoticeStoreList';

const NoticeStoreListWrap = (props) => {
  const { noticeStoreList, getList, getExcelDownload, deleteNoticeStore } = props;

  return (
    <div className="notice-store-list-wrap">
      {/* 상점 공지사항 리스트 */}
      <NoticeStoreList
        noticeStoreList={noticeStoreList}
        getList={getList}
        getExcelDownload={getExcelDownload}
        deleteNoticeStore={deleteNoticeStore}
      />
    </div>
  );
};

export default NoticeStoreListWrap;
